import type { StatPeriod } from '@solar/api-client';

/**
 * 통계 화면 공용 유틸 — 레거시 stat/*.blade.php 의 날짜 축 생성을 옮겼다.
 *
 * 서버 시계열은 값이 있는 날짜만 내려오므로(sparse), 레거시처럼 1일~말일
 * (월별이면 1~12월)을 모두 채워 0 을 명시한다.
 */

/** 레거시 연도 드롭다운 시작(2016) ~ 올해. 레거시는 2024 하드코딩이라 매년 끊겼다. */
export function yearOptions(): number[] {
  const now = new Date().getFullYear();
  const years: number[] = [];
  for (let y = 2016; y <= now; y++) years.push(y);
  return years;
}

export function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/** 조회 기간의 전체 날짜 키 — day: YYYY-MM-DD(말일까지), month: YYYY-MM(12월까지). */
export function dateKeys(year: number, month: number, period: StatPeriod): string[] {
  if (period === 'day') {
    const last = new Date(year, month, 0).getDate();
    return Array.from({ length: last }, (_, i) => `${year}-${pad2(month)}-${pad2(i + 1)}`);
  }
  return Array.from({ length: 12 }, (_, i) => `${year}-${pad2(i + 1)}`);
}

/** CSS 막대 폭(%) — 최대값 기준 비율. 데이터가 모두 0 이면 0 이 된다. */
export function barWidth(value: number, max: number): string {
  if (max <= 0) return '0%';
  return `${Math.round((value / max) * 1000) / 10}%`;
}
